/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/credit_line_transaction';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "RetrieveTransactionRequest": {
                "fields": {
                  "transactionToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "creditLineId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 3
                  },
                  "creditLineToken": {
                    "type": "string",
                    "id": 4
                  },
                  "planToken": {
                    "type": "string",
                    "id": 5
                  }
                },
                "nested": {
                  "token": {
                    "oneof": ["merchantToken", "creditLineToken", "planToken"]
                  }
                }
              },
              "RetrieveTransactionResponse": {
                "fields": {
                  "transaction": {
                    "type": ".squareup.corporate_card.resources.CreditLineTransaction",
                    "id": 1,
                    "rule": "optional"
                  },
                  "creditLineId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RetrieveTransactionRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RetrieveTransactionResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE RetrieveTransactionRequest @ squareup/corporate_card/service/retrieve_transaction.proto at 10:1
 */
export const RetrieveTransactionRequest = $root.lookupType('squareup.corporate_card.service.RetrieveTransactionRequest');
fixType(RetrieveTransactionRequest, {
  transactionToken: {
    required: true
  }
});
Builder.createAndAttachToType(RetrieveTransactionRequest);
/**
 * SOURCE RetrieveTransactionResponse @ squareup/corporate_card/service/retrieve_transaction.proto at 39:1
 */
export const RetrieveTransactionResponse = $root.lookupType('squareup.corporate_card.service.RetrieveTransactionResponse');
fixType(RetrieveTransactionResponse);
Builder.createAndAttachToType(RetrieveTransactionResponse);